import { GET_ELIGIBLE_DELEGATE_STRUCT_EMPLOYEES } from "../../../../enums/MyDivision/Delegation/RequestsDelegation.types";

export const getEligibleDelegateStructEmployeesAction = (data) => {
    return {
        type: GET_ELIGIBLE_DELEGATE_STRUCT_EMPLOYEES,
        payload: data,
    };
};